// extracted by mini-css-extract-plugin
export default {"container":"DragScroll_container_Hnpk_","containerInteractive":"DragScroll_containerInteractive_FL8DP"};